import { Dispatch } from "redux";
import * as constant from "./constantTypes";
import {
  getAssistantPages,
  IAssistantPage,
  TAssistantPages,
} from "api/getAssistantPages";
import { Actions } from "./interfaces";
import { getAssistantPageById } from "api/getAssistantPageById";
import { assistantPageCodeEnum } from "./constantTypes";
import { TypedDispatch } from "store";
import { editAssistantPage } from "api/editAssistantPage";
import { getChatKitAvailability } from "api/getChatKitAvailability";

export const SET_ASSISTANT_PAGES_LOADING = "SET_ASSISTANT_PAGES_LOADING";
export const SET_ASSISTANT_PAGES = "SET_ASSISTANT_PAGES";

export const SET_ASSISTANT_PAGE = "SET_ASSISTANT_PAGE";
export const SET_ASSISTANT_OPEN = "SET_ASSISTANT_OPEN";

export const SET_CHAT_KIT_AVAILABILITY = "SET_CHAT_KIT_AVAILABILITY";

export const setAssistantPagesLoading = (value: boolean): Actions => ({
  type: SET_ASSISTANT_PAGES_LOADING,
  payload: value,
});

export const setAssistantPages = (value: TAssistantPages): Actions => ({
  type: SET_ASSISTANT_PAGES,
  payload: value,
});

export const setAssistantPage = (value: IAssistantPage): Actions => ({
  type: SET_ASSISTANT_PAGE,
  payload: value,
});

export const setAssistantSuccessOpen = (value: boolean): Actions => ({
  type: SET_ASSISTANT_OPEN,
  payload: value,
});

export const setChatKitAvailability = (
  code: assistantPageCodeEnum,
  value: boolean
): Actions => ({
  type: SET_CHAT_KIT_AVAILABILITY,
  payload: { code, value },
});

export const defineAssistantPages = () => async (dispatch: Dispatch) => {
  dispatch(setAssistantPagesLoading(true));
  try {
    const response = await getAssistantPages();
    dispatch(setAssistantPagesLoading(false));
    dispatch(setAssistantPages(response));
  } catch (error) {
    dispatch(setAssistantPagesLoading(false));
  }
};

export const defineAssistantPage =
  (pageCode: assistantPageCodeEnum) => async (dispatch: Dispatch) => {
    dispatch(setAssistantPagesLoading(true));
    try {
      const response = await getAssistantPageById(pageCode);
      dispatch(setAssistantPagesLoading(false));
      dispatch(setAssistantPage(response));
    } catch (error) {
      dispatch(setAssistantPagesLoading(false));
    }
  };

export const updateAssistantPage =
  (assistantPage: IAssistantPage) => async (dispatch: TypedDispatch) => {
    dispatch(setAssistantPagesLoading(true));
    try {
      await editAssistantPage(assistantPage);
      await dispatch(defineAssistantPage(assistantPage.code));

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(new Error(error.code));
    } finally {
      dispatch(setAssistantPagesLoading(false));
    }
  };

export const checkChatKitAvailability =
  (code: assistantPageCodeEnum) => async (dispatch: Dispatch) => {
    try {
      const available = await getChatKitAvailability(code);
      dispatch(setChatKitAvailability(code, available));
    } catch (error) {
      dispatch(setChatKitAvailability(code, false));
    }
  };
